import http from './http.service';

class CoordinationService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/coordinations";
    }

    complete(data) {
        if (!(data instanceof FormData)) {
            throw new Error('Invalid data');
        }

        return this.$http
            .put(`${this.baseUrl}/complete`, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
    }

    start(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http
            .put(`${this.baseUrl}/start/${id}`);
    }

    create(data) {
        if (!(data instanceof FormData)) {
            throw new Error('Invalid data');
        }

        return this.$http
            .post(`${this.baseUrl}/create`, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
    }

    createFromOrganizationalDocuments(data) {
        if (!data) {
            throw new Error('Invalid data');
        }

        return this.$http
            .post(`${this.baseUrl}/createFromOrganizationalDocuments`, data);
    }

    edit(data) {
        if (!(data instanceof FormData)) {
            throw new Error('Invalid data');
        }

        return this.$http
            .post(`${this.baseUrl}/edit`, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
    }

    delete(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http
            .delete(`${this.baseUrl}/${id}`);
    }

    answer(data) {
        if (!data) {
            throw new Error('Answer is required');
        }

        return this.$http.put(`${this.baseUrl}/answer`, data);
    }

    getHistory(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/history/${id}`);
    }

    getResult(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/result/${id}`);
    }

    archive(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http
            .put(`${this.baseUrl}/archive/${id}`);
    }

    unarchive(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http
            .put(`${this.baseUrl}/unarchive/${id}`);
    }

    cancel(data) {
        if (!data) {
            throw new Error('Answer is required');
        }

        return this.$http.put(`${this.baseUrl}/cancel`, data);
    }

    getDetailsById(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/detailsById/${id}`);
    }
}

export default new CoordinationService();
